import { mediatorSettings } from "../index.js";
/**
 * Decorate the requestHandler with this attribute
 *
 * @param value The request type
 */
var requestHandler = function (value) {
    return function (target) {
        var name = value.prototype.constructor.name;
        mediatorSettings.resolver.add(name, target);
    };
};
export default requestHandler;
//# sourceMappingURL=request.attribute.js.map